import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@reenstudio/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PeriodChartApiService {
  params: any = {};
  apiUrl = environment.api;
  apiHeaders = environment.apiHeaders;

  constructor(private http: HttpClient) {}

  getPeriod(
    cer: number | null,
    site: string | number,
    start: Date,
    end: Date,
    ignoreTime: boolean = false
  ): Observable<any> {
    if (ignoreTime) {
      this.params.start = this.formatDateTime(start, 'start');
      this.params.end = this.formatDateTime(end, 'end');
    } else {
      this.params.start = this.formatDateTime(start);
      this.params.end = this.formatDateTime(end);
    }

    if (!cer) {
      delete this.params.cer_id;
    } else if (cer) {
      this.params.cer_id = cer;
    }

    if (site === 'total' || typeof site === 'string') {
      delete this.params.site_id;
    } else if (site) {
      this.params.site_id = site;
    }

    const apiUrlConsumih24 = `${this.apiUrl}/historic/period`;

    return this.http.get(apiUrlConsumih24, {
      headers: this.apiHeaders,
      params: this.params,
    });
  }

  formatDateTime(dateTime: Date, type: string = ''): string {
    if (type === 'end') {
      let stringDate = dateTime.toISOString().slice(0, 19).replace('T', ' ');
      const nuovoOrario = '23:59:59';
      let timestampString = stringDate.replace(
        /\d{2}:\d{2}:\d{2}/,
        nuovoOrario
      );
      return timestampString;
    } else if (type === 'start') {
      let stringDate = dateTime.toISOString().slice(0, 19).replace('T', ' ');
      const nuovoOrario = '00:00:01';
      let timestampString = stringDate.replace(
        /\d{2}:\d{2}:\d{2}/,
        nuovoOrario
      );
      return timestampString;
    }
    return dateTime.toISOString().slice(0, 19).replace('T', ' ');
  }
}
